import { render } from "./WeightedOptionsEditor.vue?vue&type=template&id=54ee124c&scoped=true&ts=true"
import script from "./WeightedOptionsEditor.vue?vue&type=script&lang=ts"
export * from "./WeightedOptionsEditor.vue?vue&type=script&lang=ts"

import "./WeightedOptionsEditor.vue?vue&type=style&index=0&id=54ee124c&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ee124c"]])

export default __exports__